import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../../common/Button";
import CustomSelect from "../../../common/interactive/CustomSelect";
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple";
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel";
import InputBox from "../../../common/interactive/InputBox";
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency";
import PannelBody from "../../../fragments/PannelBody";
import PannelFooter from "../../../fragments/PannelFooter";
import NewPaymentFormTableItem from "./NewPaymentFormTableItem";
import { createNegotiationPayment } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import { getPracticeNameFromId } from "../../../../lib/labels";
import { frontendOptions } from "../../../../lib/systemData";

import classes from './Create.module.css'

export default function NewPaymentForm({closeModal, sourceLimitOpt}) {
    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase) 
    const userToken = useSelector(state => state.user.token)

    const [practicesOptions, setPracticesOptions] = useState(null)

    const [isLoading, setIsLoading] = useState(false)  
    const [initialPaymentState, setInitialPaymentState] = useState({
        initialAmount: 0,
        remainingAmount: 0,
        totalBalance: 0,
        items:[]
    })
    const [status, setStatus] = useState()
    const [source, setSource] = useState()

    function selectSourceToUse(source) {
        switch (source) {
            case 'Liability':
                return 'lia_neg_amount'
            case 'UM':
                return 'um_neg_amount'         
            default:
                return 'balance'
        }
    }

    function setpracticesHandler(data) {
        let initialPaymentStateCopy = JSON.parse(JSON.stringify(initialPaymentState))
        let items = JSON.parse(JSON.stringify(initialPaymentStateCopy.items))

        if (initialPaymentState.items.length < data.data.value.length) {
            data.data.value.forEach(element => {                  
                let item = activeCase.practices.find(item => item.practice_id == Number(element))      
                if (item ) {
                    const index = items.findIndex(object => {
                        return object.id == item.practice_id
                    })
                    if (index == -1) {
                        items.push({
                            label: getPracticeNameFromId(item.practice_id),
                            is_manual: false,
                            manual_amount: null,
                            id: item.practice_id,
                            balance: item.balance,
                            lia_neg_amount: item.lia_neg_amount,
                            um_neg_amount: item.um_neg_amount,
                            amount: 0,
                            true_amount: null
                        })
                    }        
                }            
            });
        } else {
            let filtered = []
            data.data.value.forEach(element => {                  
                let item = items.find(item => item.id == Number(element))
                if (item) {
                    filtered.push(item)
                }
            });

            items = filtered
        }

        initialPaymentStateCopy.items = items
        let calculateRemaining = setRemainingAmount(initialPaymentStateCopy)

        setInitialPaymentState(calculateRemaining)
    }

    // total amount setter
    function setTotalAmountHandler(data) {
        let initialPaymentStateCopy = JSON.parse(JSON.stringify(initialPaymentState))

        initialPaymentStateCopy.initialAmount = data.data.value

        let calculateRemaining = setRemainingAmount(initialPaymentStateCopy)

        setInitialPaymentState(calculateRemaining)
    }

    function modifyItemHandler (id, amount, manual) {
        let initialPaymentStateCopy = JSON.parse(JSON.stringify(initialPaymentState))

        const index = initialPaymentStateCopy.items.findIndex(object => {
            return object.id == id
        })

        if (index !== -1) {
            if (manual) {
                initialPaymentStateCopy.items[index].manual_amount = amount
                initialPaymentStateCopy.items[index].is_manual = manual
            } else {
                initialPaymentStateCopy.items[index].manual_amount = null
                initialPaymentStateCopy.items[index].is_manual = manual
            }
            
        }

        let calculateRemaining = setRemainingAmount(initialPaymentStateCopy)

        setInitialPaymentState(calculateRemaining)
    }

    //calculate percent on balance
    function calculateAmountPercent(totalBalance, balance) {

        if (totalBalance && balance) {
            return (balance*100)/totalBalance
        }

        return null
    }

    
    // helper function to calculate the remaining for each item
    function setRemainingAmount(dataToMOdify) {
        let initialPaymentStateCopy = dataToMOdify
        if (initialPaymentStateCopy.items.length > 0) { //there are items
            let thereIsManual = initialPaymentStateCopy.items.some(item => item.is_manual)

            let totalB = 0
            initialPaymentStateCopy.items.forEach(item => {
                totalB = totalB + item[selectSourceToUse(source)]
            }) 

            initialPaymentStateCopy.totalBalance = totalB

            if (thereIsManual) { //there are manual items set
                let amount = initialPaymentStateCopy.initialAmount
                let remainingBalance = initialPaymentStateCopy.totalBalance

                initialPaymentStateCopy.items.forEach(item => {
                    if (item.is_manual) {
                        amount = amount - Number(item.manual_amount)
                        remainingBalance = remainingBalance - item[selectSourceToUse(source)]

                        item.true_amount = item.manual_amount
                    }
                })  

                initialPaymentStateCopy.remainingAmount = amount

                initialPaymentStateCopy.items.filter(item => !item.is_manual).forEach(item => {
                    if (initialPaymentStateCopy.items.filter(item => !item.is_manual).length > 1) {
                        item.amount = (amount * calculateAmountPercent(remainingBalance, item[selectSourceToUse(source)])) /100
                    } else {
                        item.amount = amount
                    }
                })   
                
                
                initialPaymentStateCopy.items.filter(item => !item.is_manual).forEach(item => {
                    if (item.amount > item[selectSourceToUse(source)]) {
                        item.true_amount = item[selectSourceToUse(source)]
                    } else {
                        item.true_amount = item.amount
                    }
                }) 

            } else { //no manual items, everything gets divided equally        
                initialPaymentStateCopy.items.forEach(item => {
                    item.amount = (initialPaymentStateCopy.initialAmount * calculateAmountPercent(initialPaymentStateCopy.totalBalance, item[selectSourceToUse(source)])) /100
                }) 

                initialPaymentStateCopy.items.forEach(item => {
                    if (item.amount > item[selectSourceToUse(source)]) {
                        item.true_amount = item[selectSourceToUse(source)]
                    } else {
                        item.true_amount = item.amount
                    }
                }) 
            }
        } else { //there are no items, but this is not going to be the case ever?
            initialPaymentStateCopy.remainingAmount = initialPaymentStateCopy.initialAmount
        }

        return initialPaymentStateCopy
    }
    // function setRemainingAmount(dataToMOdify) {
    //     let initialPaymentStateCopy = dataToMOdify

    //     if (initialPaymentStateCopy.items.length > 0) { //there are items
    //         let thereIsManual = initialPaymentStateCopy.items.some(item => item.is_manual)

    //         let totalB = 0
    //         initialPaymentStateCopy.items.forEach(item => {
    //             totalB = totalB + item.balance
    //         }) 

    //         initialPaymentStateCopy.totalBalance = totalB

    //         if (thereIsManual) { //there are manual items set
    //             let amount = initialPaymentStateCopy.initialAmount
    //             let remainingBalance = initialPaymentStateCopy.totalBalance

    //             initialPaymentStateCopy.items.forEach(item => {
    //                 if (item.is_manual) {
    //                     amount = amount - Number(item.manual_amount)
    //                     remainingBalance = remainingBalance - item.balance

    //                     item.true_amount = item.manual_amount
    //                 }
    //             })  

    //             initialPaymentStateCopy.remainingAmount = amount

    //             initialPaymentStateCopy.items.filter(item => !item.is_manual).forEach(item => {
    //                 if (initialPaymentStateCopy.items.filter(item => !item.is_manual).length > 1) {
    //                     item.amount = (amount * calculateAmountPercent(remainingBalance, item.balance)) /100
    //                 } else {
    //                     item.amount = amount
    //                 }
    //             })   
                
                
    //             initialPaymentStateCopy.items.filter(item => !item.is_manual).forEach(item => {
    //                 if (item.amount > item.balance) {
    //                     item.true_amount = item.balance
    //                 } else {
    //                     item.true_amount = item.amount
    //                 }
    //             }) 

    //         } else { //no manual items, everything gets divided equally        
    //             initialPaymentStateCopy.items.forEach(item => {
    //                 item.amount = (initialPaymentStateCopy.initialAmount * calculateAmountPercent(initialPaymentStateCopy.totalBalance, item.balance)) /100
    //             }) 

    //             initialPaymentStateCopy.items.forEach(item => {
    //                 if (item.amount > item.balance) {
    //                     item.true_amount = item.balance
    //                 } else {
    //                     item.true_amount = item.amount
    //                 }
    //             }) 
    //         }
    //     } else { //there are no items, but this is not going to be the case ever?
    //         initialPaymentStateCopy.remainingAmount = initialPaymentStateCopy.initialAmount
    //     }

    //     return initialPaymentStateCopy
    // }

        
    function statusChangeHandler(value) {
        setStatus(value.data.value)
    }
    
    function sourceChangeHandler(value) {
        setSource(value.data.value)

        let initialPaymentStateCopy = JSON.parse(JSON.stringify(initialPaymentState))
        let calculateRemaining = setRemainingAmount(initialPaymentStateCopy)
        setInitialPaymentState(calculateRemaining)
    }
    
    //crate the payment
    async function createNewPayment(event) {
        event.preventDefault()
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            const body = {
                receipt_date: formData.receipt_date,
                check_number: formData.check_number,
                amount: Number(initialPaymentState.initialAmount),
                status: formData.status,//Hold, Accepted, Ignore
                source: formData.source, //Liability, UM
                payee: formData.payee,
                practices: []
            }

            if (initialPaymentState.items) {
                initialPaymentState.items.forEach(item => {
                    body.practices.push({
                        practice_id: item.id,
                        amount: Number(item.true_amount)
                    })
                })
            }

            if (body.receipt_date && body.source && body.status && body.payee) {
                let payment = await createNegotiationPayment(userToken, activeCase.case.id, body, dispatch)

                if (payment?.errorMessage) {
                    dispatch(notificationActions.setError(payment))
                } else {       
                    if (closeModal) {
                        closeModal()
                    }

                    dispatch(caseActions.createOrUpdatePayment(payment))     
                } 
            }
        } finally {
            setIsLoading(false)
        }    

    }

    useEffect(() => {
        let options = []
        if (activeCase && activeCase.practices) {
            activeCase.practices.forEach(item => {
                options.push({
                    label: getPracticeNameFromId(item.practice_id),
                    value: item.practice_id,
                })
            })

            setPracticesOptions(options)
        }

    }, [activeCase])


    return <form  onSubmit={createNewPayment}>
        <PannelBody>
            <div className={classes.name_container}>
                <DatepickerWithLabel name={'receipt_date'} label={'Date of receipt'} required={true}/>
                <InputBox name={'check_number'} label={'Check #'} required={true}/>
            </div>
            
            <div className={`row`}>
                <InputBox name={'payee'} label={'Payee'} required={true}/>
            </div>

            <div className={`row`}>
                <InputBoxCurrency action={setTotalAmountHandler} name={'amount'} label={'Amount'} identifier={{type: null, field: 'amount', type_id: null, folder: null}} fullBox={true} required={true}/>
            </div>
            
            <div className={classes.name_container}>
                <CustomSelect name={'status'} label={'Status'} optionsData={frontendOptions()?.checkStatusOptions} preSelectedValue={status} action={statusChangeHandler}/>
                <CustomSelect name={'source'} label={'Source'} required={true} optionsData={frontendOptions()?.newPaymentSourceOptions.filter(item => sourceLimitOpt.includes(item.value))} rtlDrawer={true} preSelectedValue={source} action={sourceChangeHandler}/>
            </div>
            
            <div className={`row`}>
                {practicesOptions && <CustomSelectMultiple action={setpracticesHandler} name={'practices'} label={'Practices'} optionsData={practicesOptions} isDisabled={!source}/>}
            </div>

            <div className={`row`}>
                <table>
                    <thead>
                        <tr>
                            <th>Practices</th>
                            {/* <th>Balance</th> */}
                            <th>Neg. Amount</th>
                            <th>Amount</th>
                            <th>Manual</th>
                        </tr>
                    </thead>
                    <tbody>
                        {initialPaymentState && initialPaymentState.items.map(item => (
                            <NewPaymentFormTableItem key={item.id} remainingAmount={initialPaymentState.remainingAmount} totalAmount={initialPaymentState.initialAmount} tableItems={initialPaymentState.items} item={item} modifyItem={modifyItemHandler} totalItems={initialPaymentState.items.length} selectedSource={source}/>
                        ))}
                    </tbody>

                </table>

                {(initialPaymentState.items.length > 0 && initialPaymentState.initialAmount !== 0) && <div className={classes.message}>
                    {(initialPaymentState.initialAmount > initialPaymentState.totalBalance) && <>The amount exceeds the total balance!</>}
                    {(initialPaymentState.initialAmount < initialPaymentState.totalBalance) && <>The amount is lower than the total balance!</>}
                </div>}
            </div>

            
            
        </PannelBody>
        <PannelFooter>
            <Button type='submit' isLoading={isLoading} width={'full'} isDisabled={!source}>
                Submit 
                <i className="ti ti-chevron-right"></i>
            </Button>
        </PannelFooter>
    </form>
}